import { selectNotifications } from "Redux/Notifications/slice";
import {
  INotification,
  NOTIFICATIONS_APP_NAME,
} from "Shared/Types/notifications";
import dayjs from "dayjs";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { displayDate } from "Shared/Utils/display";
import { API_DATE_FORMAT } from "Shared/Constants/app";

export const groupNotifications = (notifications: INotification[]) => {
  const groups = new Map<
    string,
    {
      day: { number: string; title: string };
      list: { app_name: NOTIFICATIONS_APP_NAME; list: INotification[] }[];
    }
  >();
  [...notifications]
    .sort((a, b) => dayjs(b.created).valueOf() - dayjs(a.created).valueOf())
    .forEach((notification) => {
      const date = dayjs(notification.created);
      const key = date.format(API_DATE_FORMAT);
      if (!groups.has(key)) {
        groups.set(key, {
          day: {
            number: key,
            title: date.isSame(dayjs(), "day")
              ? "Today"
              : displayDate(notification.created),
          },
          list: [],
        });
      }
      const group = groups.get(key);
      if (!group) return;
      const category = group.list.find(
        (item) => item.app_name === notification.app_name,
      );
      if (category) category.list.push(notification);
      else
        group.list.push({
          app_name: notification.app_name,
          list: [notification],
        });
    });
  return Array.from(groups.values());
};

export const useNotification = () => {
  const notifications = useSelector(selectNotifications);
  const notificationsList = useMemo(
    () => groupNotifications(notifications.results),
    [notifications.results],
  );
  return { notificationsList };
};
